export enum GeolocationErrorCode {
  DENIED,
  NOT_ALLOWED,
}

type GeolocationError = { [key in GeolocationErrorCode]: string }

// todo
export const geolocationError: GeolocationError = {
  0: '위치정보 제공을 거부한 사용자입니다.',
  1: 'Only secure origins are allowed',
}

export const LOCATION_COOKIE_KEY = 'm_loc'

export const isLocationInCookie = (cookie: string): boolean => {
  return getCookieValue(cookie, LOCATION_COOKIE_KEY) != null
}

export const getCookieValue = (cookie: string, key: string): string => {
  if (!cookie || !key) return
  const keyPrefix = `${key}=`
  const cookies = cookie.split(';')
  const searchedCookie = cookies.map(c => c.trim()).find(c => c.startsWith(keyPrefix))
  return searchedCookie && searchedCookie.replace(keyPrefix, '')
}
